import { formatLocalTime, isTodayInTz } from '../../utils/time';
import { useTranslation } from '../../i18n';

interface Props {
  source: 'schedule' | 'window';
  until: Date | string;
  startsAt?: Date | string;
  timezone?: string;
}

export function AvailabilityPill({ source, until, startsAt, timezone = 'UTC' }: Props) {
  const { t, language } = useTranslation();
  const isSchedule = source === 'schedule';
  const chipClass  = isSchedule ? 'chip chip-sched' : 'chip chip-window';
  const label      = isSchedule ? t('schedule') : t('window');

  function fmtInTz(d: Date | string): string {
    const iso = d instanceof Date ? d.toISOString() : d;
    return isTodayInTz(iso, timezone)
      ? formatLocalTime(iso, timezone, 'time', language)
      : formatLocalTime(iso, timezone, 'datetime-weekday', language);
  }

  const timeText = startsAt
    ? `${t('from')} ${fmtInTz(startsAt)}`
    : `${t('until')} ${fmtInTz(until)}`;

  return (
    <span className={chipClass}>
      {label} · {timeText}
    </span>
  );
}
